module.exports = __webpack_public_path__ + "img/ic24Account.c75149b8.svg";